import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import React, { useState, useEffect } from 'react'
import { ModalWrapper } from "./ModalWrapper";

import { useSelector } from "react-redux";
import { useNavigation } from "@react-navigation/native";
import { useRoute } from '@react-navigation/native';
import { switchScreen } from '../../../../hooks/navigate';
import useIsMounted from '../../../../hooks/mounted';

import i18n from "i18n-js";

export const ContactConfirm = (modal) => {

  const mounted = useIsMounted()
  const navigation = useNavigation();
  const route = useRoute();

  const isWaiting = modal.option?.request?.isWaiting ?? false;
  const isAcknowledged = modal.option?.request?.isAcknowledged ?? false;
  const hasIssues = modal.option?.request?.issues ?? {};

  const contact = useSelector((state) => state.contacts.active) //
    .filter(_ => _.id === modal.option?.contact?.id)[0] ?? {};

  const [inputd_contact_name, onInputdContactName] = useState();
  const [do_submit_on_mounted, setSubmitOnUnMounted] = useState(false);

  if (isAcknowledged) {
    modal.onClose();
  }

  useEffect(() => {
    if (contact?.id) {
      // ? restore values for update
      onInputdContactName(contact?.toUser.preferredName ?? '');
      setSubmitOnUnMounted(false);
    }
  }, [contact]);

  const onBack = () => {
    modal.onClose();
  }

  const onSubmit = () => { 
    if (!route.params || !('k' in route.params)) {
      submitInputs({ contact });
      return;
    }

    setSubmitOnUnMounted(true);
    switchScreen(navigation, 'contacts');
  }

  useEffect(() => {
    return () => {
      if (!mounted() && do_submit_on_mounted) {
        submitInputs({ contact });
      }
    };
  }, [mounted])

  const submitInputs = ({ contact }) => {
    const request = { isWaiting: false, isAcknowledged: false, issues: null };

    // ? request
    request.isWaiting = true;
    request.isAcknowledged = true;

    modal.onUpdate({ request });

    // dispatch(backendRequest('DELETE_REQUEST_INLINE', '/contact/request', { userId: request.toUser.id, requestId: request.id }, 'DELETE'))
    //  .then(contacts => console.log('DEL', contacts))

    // dispatch(backendRequest('DELETE_CONTACT_INLINE', '/contact/' + contact.id, null, 'DELETE', false))

    modal.onRequest('DELETE_CONTACT_INLINE', '/contact/' + contact.id, (
      (null) //
    ), 'DELETE').then((data) => {
      // ---
      console.debug('[Modal]', 'onRequest.then', !!data.result, data?.result)
      // ---
    })
  }

  // const [image, setImage] = useState(contact?.contactImage?.id)

  return (
    <ModalWrapper
      onClose={modal.onClose}
      onBack={onBack}
      onSubmit={onSubmit}

      isVisible={modal.isVisible}
      isWaiting={isWaiting}

      title={i18n.t('contact.deleteContact')}
      buttonBack={{ text: i18n.t('addContact.cancel') }}
      buttonSubmit={{ text: i18n.t('contact.delete'), action: 'negative' }}
    >
      <Text className="text-md text-secondary-600">{i18n.t('contact.deleteContactText', { user: inputd_contact_name })}</Text>
      <VStack>
        {'request-failed' in hasIssues && (
          <Text className="mt-2 text-xs text-error-600">{hasIssues['request-failed']}</Text>
        )}
      </VStack>
    </ModalWrapper>
  );
}
